<template>
  <div id="detail" :class="['w3-modal', 'detail-wrapper', currentDetailContentId]" @click="clickDetailAndClose">
    <div class="w3-modal-content">
      <div class="w3-container w3-row detail-area">
        <div v-if="definitionTitle !== ''" class="definition-title" v-html="definitionTitle"></div>
        <div class="container_menu_detail">
          <div v-if="menu" class="detail-menu-container">
            <div v-for="item in filteredMenu" :key="item.id" :class="item.id">
              <detail-flap
                :name="item.id"
                :id="id"
                :detailDefinitionChanged="detailDefinitionChanged"
                :visualDefinition="visualDefinition"
                :title="item.name"
                @continueWithoutSaving="continueWithoutSaving"
                @continueSaving="continueSaving"
                @flapClicked="flapClicked"
              />
            </div>
          </div>
        </div>
        <simplebar data-simplebar-auto-hide="false">
          <div v-bind:id="currentDetailContentId" :class="['container_detail', 'w3-rest', {noButtons : visualDefinition.definition && visualDefinition.definition.hideButtons}]">
            <div :class="['container_inner_detail']">
              <span class="w3-display-topright close_detail">
                <i class="fas fa-angle-left" @click="closeDetail()"></i>
              </span>

              <div class="detail" v-show="!loadingDetail">
                <div origin-left="true" transition-duration="false" item-selector=".item">
                  <router-view v-slot="{ Component }">
                    <transition name="fade" mode="out-in">
                      <keep-alive v-if="currentDetailContent && currentDetailContent.requestSearcher">
                        <component :is="Component"
                          class="detail-view"
                          :key="`${$route.name}-${currentDetailContent.id}-${id}`"
                          :searcher="currentDetailContent.requestSearcher"
                          :contentId="currentDetailContent.id"
                          :apiDefinitionId="id"
                          @searcherLoaded="detailLoaded"
                          @refreshDefinitionTitle="refreshDefinitionTitle"
                        />
                      </keep-alive>
                      <component :is="Component" v-else
                        class="detail-view"
                        :key="`${$route.name}-${id}`"
                        :saveDefinition="saveDefinition"
                        :saveDefinitionTo="saveDefinitionTo"
                        :apiDefinitionId="id"
                        @formDataActionCalled="formDataActionCalled"
                        @refreshDefinition="definitionChanged"
                        @validatingFormError="validatingFormError"
                        @definitionLoaded="detailLoaded"
                        @definitionError="definitionError"
                        @refreshDefinitionTitle="refreshDefinitionTitle"
                      />
                    </transition>
                  </router-view>
                </div>
              </div>
            </div>
          </div>
        </simplebar>
      </div>
    </div>
  </div>
</template>

<script>
import * as controlPanelTypes from '@/store/actions/controlPanel'
import * as appTypes from '@/store/actions/app'
import DetailFlap from '@/components/content/detail/flap'
import menu from '@/utils/menu'
import transport from 'vue-definition-utils/src/utils/transport'
import Visual from 'vue-definition-utils/src/utils/visual'
import simplebar from 'simplebar-vue'
import 'simplebar-core/dist/simplebar.css'

export default {
  name: 'detail',
  props: [
    'menu',
    'detailId',
    'definition',
    'object'
  ],
  components: {
    DetailFlap,
    simplebar
  },
  data () {
    return {
      currentContentPath: '',
      currentDetailContent: null,
      currentDetailContentId: null,
      id: '',
      detailDefinitionChanged: false,
      saveDefinition: false,
      saveDefinitionTo: null,
      loadingDetail: true,
      closing: false,
      visualDefinition: null,
      definitionTitle: ''
    }
  },
  methods: {
    flapClicked (name) {
      this.loadingDetail = true
    },
    detailLoaded (content) {
      this.loadingDetail = false
    },
    formDataActionCalled (stay) {
      this.detailDefinitionChanged = false
      if (!stay && this.saveDefinitionTo === null) {
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, false)
        this.goToParentMenu()
      }
      this.saveDefinitionTo = null
      this.saveDefinition = false
      this.$emit('formDataActionCalled')
    },
    closeDetail () {
      this.closing = true
      if (((!this.detailDefinitionChanged || (this.visualDefinition.definition && this.visualDefinition.definition.hideButtons)) && this.menu[0].type.id !== 'template') || transport.methods.allDefinitionReadable(this.currentDetailContent.requestDefinition)) {
        this.closeDetailWindow()
      } else {
        // Dialog
        let message = this.$ml.get('saveChangesAfterClose')
        let options = {
          okText: this.$ml.get('save'),
          cancelText: this.$ml.get('continueWithoutSaving'),
          customClass: 'sherpaDialog'
        }
        this.$dialog.confirm(message, options)
          .then((dialog) => {
            this.saveDefinition = true
          })
          .catch(() => {
            this.closeDetailWindow()
          })
      }
    },
    closeDetailWindow () {
      // this.$router.push(this.currentContentPath).catch(() => {})
      this.$router.go(-1)
    },
    goToParentMenu () {
      var path = this.$route.matched[this.$route.matched.length - 1].path
      var menuParent = menu.methods.getDefaultParentMenuPath(null, this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], path)
      if (menuParent) {
        this.$router.push(menuParent.parentContextPath + menuParent.contextPath).catch(() => {})
      }
    },
    definitionChanged (requestObject, changed) {
      this.detailDefinitionChanged = changed
    },
    continueWithoutSaving () {
      this.detailDefinitionChanged = false
    },
    continueSaving (to) {
      this.saveDefinitionTo = to
      this.saveDefinition = true
    },
    validatingFormError () {
      this.saveDefinitionTo = null
      this.saveDefinition = false
    },
    getCurrentDetailName () {
      var result = null
      for (var i = 0; i < this.menu.length && !result; i++) {
        if (this.currentDetailContentId === this.menu[i].id) {
          result = this.menu[i].name
        }
      }
      return result
    },
    clickDetailAndClose (event) {
      // close detail if click is out of content
      if (event.target.id === 'detail') {
        // this.closeDetail()
      } else {
        var detailClassFound = false
        for (var i = 0; i < event.target.classList.length && !detailClassFound; i++) {
          detailClassFound = (event.target.classList[i] === 'detail-area')
        }
        if (detailClassFound) {
          // this.closeDetail()
        }
      }
    },
    refreshDefinitionTitle (definitionTitle) {
      this.definitionTitle = definitionTitle
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_TITLE}`, definitionTitle)
    },
    definitionError (error, resultError, container) {
      this.$emit('definitionError', error, resultError, container)
    },
    setId (newId) {
      this.id = newId
      if (this.id === null) {
        if (this.$route.params.id) {
          this.id = this.$route.params.id
        } else if (this.currentDetailContent && this.currentDetailContent.requestDefinition && this.currentDetailContent.requestObject) {
          this.id = transport.methods.getIdValue(this.currentDetailContent.requestDefinition, this.currentDetailContent.requestObject)
        }
      }
    }
  },
  beforeMount () {
    var currentContent = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`]
    this.currentContentPath = currentContent.parentContextPath + currentContent.contextPath
    this.currentDetailContent = this.newCurrentDetailContent
    if (this.currentDetailContent) {
      this.currentDetailContentId = this.currentDetailContent.id
    }

    this.visualDefinition = new Visual(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_VISUALS}`], this.currentDetailContentId)

    this.setId(this.detailId)

    this.$store.dispatch(`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}/${controlPanelTypes.CONTROL_PANEL_CLOSE}`)
  },
  computed: {
    newCurrentDetailContent () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_CONTENT}`]
    },
    filteredMenu () {
      var result = []

      this.menu.forEach((menuItem, index) => {
        if (menuItem && menuItem.type && menuItem.type.endpoint) {
          result.push(menuItem)
        }
      })

      return result
    }
  },
  watch: {
    newCurrentDetailContent (newCurrentDetailContent) {
      this.currentDetailContent = newCurrentDetailContent
      if (this.currentDetailContent && this.currentDetailContent.requestDefinition && this.currentDetailContent.requestObject) {
        this.currentDetailContentId = this.currentDetailContent.id

        this.setId(transport.methods.getIdValue(this.currentDetailContent.requestDefinition, this.currentDetailContent.requestObject))

        if (this.currentDetailContentId) {
          this.visualDefinition = new Visual(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_VISUALS}`], this.currentDetailContentId)
        }
      }
    }
  }
}
</script>

<style lang="scss">
/* Entrada suave del CONTENIDO del flap: cada cambio de flap re-monta .detail-view
   (su :key incluye $route.name), así que una animación de mount da un fade + leve
   slide fiable en todos los flaps (form y searcher), sin el "hueco" del out-in ni
   depender de la transición de router anidada. La barra de tabs no se re-monta. */
.detail-view {
  animation: detailFlapIn 0.26s cubic-bezier(0.22, 1, 0.36, 1);
}
@keyframes detailFlapIn {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.loadingDetail {
  position: absolute;
  top: calc(50% - 16px);
  left: 0;
  right: 0;
}

#detail {
  display: block !important;
  padding-top: 0;
  left: 111px;
  top: 89px;
  right: 11px;
  bottom: 62px;
  width: auto;
  height: auto;
  z-index: 0;

  > .w3-modal-content {
    width: 100%;
    height: 100%;
    overflow: hidden;

    > .w3-container {
      margin: 0;
      padding: 0;
      height: 100%;
      overflow: hidden;

      .detail-menu-container {
        border-bottom: 1px dotted #bbb;
      }

      .definition-title {
        float: left;
        background-color: #000;
        padding: 4px 12px 2px;
        font-family: "Source Sans Pro", sans-serif;
        font-size: 16px;
        font-weight: 600;
        color: #f8f8f8;
        min-height: 34px;
      }

      .container_menu_detail {
        .detail-menu-container {
          background-color: #efefef;
          margin-top: 0px;
          max-height: 35px;
          overflow-y: auto;

          > div {
           display: inline-block;
           padding: 0 4px 0 5px;
          }

          button {
            text-decoration: none;
            padding: 7px 5px 8px 5px;
            border: 0;
            cursor: pointer;
            background-color: transparent;

            > div {
              position: relative;
              transition: background-color 0.2s ease-in;

              .icon_menu {
                text-align: center;
                font-family: "Source Sans Pro", sans-serif;
                font-size: 15px;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: right;
              }
            }
          }

          button.link-active > div .icon_menu,
          button:hover > div .icon_menu{
            color: #000;
            transition: all 0.2s ease-in;
            box-shadow: 0px -2px 0px #d42e12 inset;
          }

          .tooltip {
            top: 13px !important;
            left: 55px !important;
            transform: initial !important;
            white-space: nowrap;
          }
        }
      }

      > [data-simplebar] {
        position: absolute;
        top: 35px;
        bottom: 0;
        width: 100%;
      }

      .slot {
        [data-simplebar] {
          top: 20px;

          > .simplebar-wrapper {
            bottom: 0;
            top: 0;
            position: absolute;
          }
        }
      }

      .container_detail {
        background-color: white;
        bottom: 0px;
        width: 100%;
        margin-top: 10px;

        > .container_inner_detail {
          .definition-wrapper.group {
            float: left;
          }

          .close_detail {
            bottom: 11px;
            top: auto;
            left: 122px;
            color: #ff7643;
            cursor: pointer;
            z-index: 20000000;
            position: fixed;
            width: 17px;

            i {
              font-size: 33px;
              transition: color 0.2s ease-in;

              &:hover {
                color: #d42e12;
              }
            }
          }

          .detail {
            .definition-title {
              background-color: #fff;
              border-bottom: 1px dotted #cfcfcf;
              padding-left: 0px;
              display: none;
            }

            .apartat_detail {
              width: 100%;
              min-height: 130px;
              margin: 10px 0;
              padding: 5px 15px;
              background-color: #efefef;

              p {
                font-family: 'Noto Sans';
                font-size: 1.2em;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 1;
                letter-spacing: normal;
                color: #000;
              }

              ul {
                list-style: none;

                li span {
                  font-family: 'Noto Sans';
                  font-size: 1em;
                  font-weight: normal;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 1.25;
                  letter-spacing: normal;
                  color: #000;
                }

                span:first-child {
                  font-weight: bold;
                }
              }
            }

            .template-mosaico {
              .languageSelectorOrTask {
                top: -17px;
              }
            }

            .html {
              #gjs {
                position: absolute;
                left: 20px;
                right: 18px;
                top: 17px;
                bottom: 70px;
                width: initial !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#contenidor_plantilles {
  margin: 30px 0 100px;
  padding: 0;

  #pujar_plantilla {
    position: relative;
    width: 20%;
    height: 240px;
    background-color: #fffcf5;
    border-radius: 8px;
    border: 2px dashed #ffbf28;
  }
}
#contenidor_menu_plantilles {
  margin-top: 30px;

  .slider_plantilles {
    width: 100%;
    height: auto;
    padding: 0 100px;
    overflow: hidden;

    #ctrl_esquerra_items {
      position: absolute;
      top: 90px;
      left: -45px;
      z-index: 99;
      color: #ff7643;
      cursor: pointer;
    }

    #ctrl_dreta_items {
      position: absolute;
      top: 90px;
      right: -45px;
      z-index: 99;
      color: #ff7643;
      cursor: pointer;
    }

    .slick-slide {
      width: 100%;
      height: 240px;
      padding: 0 15px;
      opacity: 0.3;
      overflow: hidden;
    }

    .slick-center {
      opacity: 1;
    }

    .plantilla img {
      width: 100%;
      max-height: 400px;
    }
  }
}
</style>
